import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { TenantFlow } from '@lib/enums';
import { TenantConfigurationService } from '@lib/services';

export const tenantAccessGuard = (flow: TenantFlow): CanMatchFn => {
    return () => {
        const tenantConfigurationService = inject(TenantConfigurationService);
        if (tenantConfigurationService.isTenantAllowed(localStorage.getItem('tenantKey') || '', flow)) {
            return true;
        }

        return false;
    };
};
